import pieComponent from './pie';

export default function pie(picasso) {
  picasso.component('pie', pieComponent);
}
